import { useContext } from 'react'
import { FirmFragment } from '~/graphql/generated/query.types'

import { FirmContext } from '~/util/FirmContext'

export function useFirm(): FirmFragment {
  return useContext(FirmContext)[0]
}
